import React, { useState } from 'react';


const testimonials = [
  { name: "Rajiv Sharma", role: "New York", text: "The fuel monitoring system detected theft that was costing us lakhs every month.", stars: 4 },
  { name: "Priya Desai", role: "New York", text: "The fuel monitoring system detected theft that was costing us lakhs every month.", stars: 5, active: true },
  { name: "Ananya Patel", role: "New York", text: "The fuel monitoring system detected theft that was costing us lakhs every month.", stars: 4 },
];

const getColumnTestimonials = (columnIndex) => {
  const rotatedTestimonials = [
    ...testimonials.slice(columnIndex),
    ...testimonials.slice(0, columnIndex),
  ];

  return [...rotatedTestimonials, ...rotatedTestimonials];
};

const TestimonialSlider = () => {
  const mobileTestimonials = [
    testimonials[testimonials.length - 1],
    ...testimonials,
    testimonials[0],
  ];
  const [mobileSlide, setMobileSlide] = useState(1);
  const [mobileTransition, setMobileTransition] = useState(true);

  const showPreviousSlide = () => {
    setMobileTransition(true);
    setMobileSlide((current) => current - 1);
  };

  const showNextSlide = () => {
    setMobileTransition(true);
    setMobileSlide((current) => current + 1);
  };

  const handleMobileTransitionEnd = () => {
    if (mobileSlide === 0 || mobileSlide === testimonials.length + 1) {
      setMobileTransition(false);
      setMobileSlide(mobileSlide === 0 ? testimonials.length : 1);
    }
  };

  const visibleMobileSlide =
    ((mobileSlide - 1 + testimonials.length) % testimonials.length) + 1;

  return (
    <section className="overflow-hidden bg-gray-50 px-4 py-14 sm:px-6 sm:py-20">
      <div className="mb-10 text-center sm:mb-16">
        <h2 className="mb-4 text-3xl font-bold sm:text-4xl">What Our Clients Say</h2>
        <p className="text-sm text-gray-600 sm:text-base">Hear from businesses who have transformed their fleet operations.</p>
      </div>

      <div className="mx-auto hidden h-[430px] w-full max-w-6xl gap-6 overflow-hidden sm:grid sm:grid-cols-2 md:grid-cols-3">
        {[0, 1, 2].map((columnIndex) => (
          <div
            key={columnIndex}
            className={`testimonial-column overflow-hidden ${
              columnIndex === 1 ? "hidden sm:block" : ""
            } ${columnIndex === 2 ? "hidden md:block" : ""}`}
          >
            <div
              className={`testimonial-column-track ${
                columnIndex === 1 ? "testimonial-column-track-reverse" : ""
              }`}
              style={{
                animationDuration: `${16 + columnIndex * 3}s`,
                animationDelay: `${columnIndex * -4}s`,
              }}
            >
              {getColumnTestimonials(columnIndex).map((testimonial, cardIndex) => (
                <article
                  key={`${columnIndex}-${cardIndex}`}
                  className={`testimonial-card min-h-[190px] rounded-2xl p-6 shadow-lg ${
                    testimonial.active
                      ? "bg-orange-500 text-white"
                      : "bg-white text-gray-900"
                  }`}
                >
                  <div className="mb-4 flex items-center gap-4">
                    <div className="h-12 w-12 shrink-0 rounded-full bg-gray-300" />
                    <div>
                      <h4 className="font-bold">{testimonial.name}</h4>
                      <p className="text-sm opacity-80">{testimonial.role}</p>
                    </div>
                  </div>
                  <div className="mb-2 text-yellow-400">
                    {"★".repeat(testimonial.stars)}
                  </div>
                  <p className="text-sm leading-relaxed">{testimonial.text}</p>
                </article>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mx-auto h-[230px] w-full overflow-hidden sm:hidden">
        <div
          className={`mobile-testimonial-track ${
            mobileTransition ? "mobile-testimonial-track-transition" : ""
          }`}
          style={{
            "--mobile-translate": `calc(${-mobileSlide * 100}vw + ${mobileSlide * 2}rem)`,
          }}
          onTransitionEnd={handleMobileTransitionEnd}
        >
          {mobileTestimonials.map((testimonial, index) => (
            <article
              key={`${testimonial.name}-${index}`}
              className={`mobile-testimonial-card min-h-[210px] rounded-2xl p-6 shadow-lg ${
                testimonial.active
                  ? "bg-orange-500 text-white"
                  : "bg-white text-gray-900"
              }`}
            >
              <div className="mb-4 flex items-center gap-4">
                <div className="h-12 w-12 shrink-0 rounded-full bg-gray-300" />
                <div>
                  <h4 className="font-bold">{testimonial.name}</h4>
                  <p className="text-sm opacity-80">{testimonial.role}</p>
                </div>
              </div>
              <div className="mb-2 text-yellow-400">
                {"★".repeat(testimonial.stars)}
              </div>
              <p className="text-sm leading-relaxed">{testimonial.text}</p>
            </article>
          ))}
        </div>
      </div>

      <div className="mt-6 flex items-center justify-center gap-4 sm:hidden">
        <button
          type="button"
          onClick={showPreviousSlide}
          aria-label="Show previous testimonial"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-orange-500 bg-white text-2xl text-orange-500 shadow transition active:scale-95"
        >
          ‹
        </button>

        <span className="min-w-14 text-center text-sm font-semibold text-slate-600">
          {visibleMobileSlide} / {testimonials.length}
        </span>

        <button
          type="button"
          onClick={showNextSlide}
          aria-label="Show next testimonial"
          className="flex h-11 w-11 items-center justify-center rounded-full bg-orange-500 text-2xl text-white shadow transition active:scale-95"
        >
          ›
        </button>
      </div>
    </section>
  );
};

export default TestimonialSlider;
